module.exports = {
  employed: "employed",
  self_employed: "self_employed",
  student: "student",
  unemployed: "unemployed",
  retired: "retired",
  public_servant: "public_servant",
  company: "company",
  domestic_worker: "domestic_worker",
  public_servant_subcategories: ["military", "publicServant"],
  employed_subcategories: [
    "permanent",
    "temporary",
    "permanent_seasonal_worker",
    "paternity_or_maternity_leave",
    "medical_leave",
    "domestic_worker",
  ],
  self_employed_subcategories: ["ownACompany", "freelancer"],
  pension_certificate: "Pension certificate",
  last_revalorization_letter: "Last revalorization letter",
  comprehensive_certificate_of_benefits:
    "Comprehensive certificate of benefits",
  national_id: "National Id",
  university_acceptance_letter: "University Acceptance Letter",
  certificate_of_social_security_compliance:
    "Certificate proving disability status",
  certificate_of_tax_compliance: "Certificate of Tax Compliance",
  annual_corporate_tax: "Annual Corporate Tax",
  certificate_of_account_ownership: "Certificate of Account Ownership",
  certificate_of_account_balance: "Certificate of Account Balance",
  alternative_income_sources: "Alternative Income sources",
  recent_utility_bill: "Recent utility Bill",
  ie_student: "Student registration contract",
  guarantor: "Guarantor",
  employment_contract: "Employment contract",
  payslips: "Last 3 payslips",
  payslip: "Payslip",
  annual_payment_certificate: "Annual payment certificate",
  firstMonthPayslip: "1st month payslip",
  secondMonthPayslip: "2nd month payslip",
  thirdMonthPayslip: "3rd month payslip",
  contribution_bases: "Contribution Bases",
  appointment_of_a_civil_servant:
    "Appointment of a civil servant or publication in the Official State Gazette",
  certificate_of_Professional_Life:
    "Certificate of Services Rendered or Certificate of Professional Life",
  previous_working_life_certificate: "Working life certificate",
  others: "others",
  income_tax_return: "Last annual Tax Report (Model 100)",
  deduction_certificate: "Deduction certificate",
  public_appointment_certificate:
    "Public appointment certificate (only if public employee)",
  quarterly_vat: "Last quarterly VAT tax (Form 303)",
  fractioned_tax_return: "Last Fractionated Tax Report (Model 130)",
  self_employed_certificate: "Self-Employed Registration Certificate",
  corporate_tax_return: "Last year's Corporate Tax Return",
  corporate_balance_sheet: "Last year's Corporate balance sheet",
  corporate_PL: "Last year's Corporate P&L",
  companyIncorporationDocuments: "Company Incorporation Documents",
  officialappointmentNotice: "Official Appointment Notice (Official Gazette)",
  TENANT_PENDING: "tenant_pending",
  AWARDED: "awarded",
  LANDLORD_PENDING: "landlord_pending",
  DEPOSIT: "deposit",
  RENT: "rent",
  PENDING: "pending",
  COMPLETED: "completed",
  PROCESSING: "processing",
  SUBSCRIPTION_PERCENTAGE: 0.1,
  SKOR_DEPOSIT: "skor_deposit",
  FULL_DEPOSIT: "full_deposit",
  PROFILE_COMPLETE_POINTS: 20,
  DOCS_COMPLETE_POINTS: 50,
  ASSIGNED_PROPERTY: "assigned_property",
  RENTAL_INFO: "rental_info",
  PARTIAL_RENT: "partial rent",
  RENT_DEPOSIT: "rent & deposit",
  SKOR: "skor",
  MACC: "macc",
  OTHER: "other",
  regulatory_agreement_in_case_of_divorce_separation:
    "Regulatory agreement in case of divorce/separation",
  revalued_pension_certificate: "Revalued pension certificate",
  family_book_marriage_civil_partnership_birth_certificate:
    "Family book, marriage/civil partnership/birth certificate",
  certificate_of_residency_registration:
    "Certificate of Residency Registration",
  no_special_circumstances: "No special circumstances",
  certificate_proving_disability_status:
    "Certificate proving disability status",
  homeOwnershipCertificate: "Home Ownership certificate",
  public_housing_fileFrom: "public_housing_docs",
  constitution_document: "Company Incorporation Documents", // Using "Company Incorporation Documents" (Model 190)" as we are getting this type from skor lite
  PROFESSION_DOCS: {
    STUDENT_DOCS: {
      "University Acceptance Letter": "University Acceptance Letter",
      "Student registration contract": "Student registration contract",
    },
    EMPLOYED_DOCS: {
      Payslip: "Payslip",
      "Employment contract": "Employment contract",
      "Deduction certificate": "Deduction certificate",
      "Working life certificate": "Working life certificate",
      "Last annual Tax Report (Model 100)":
        "Last annual Tax Report (Model 100)",
    },
    DOMESTIC_WORKER_DOCS: {
      "Annual payment certificate": "Annual payment certificate",
      "Employment contract": "Employment contract",
      "Deduction certificate": "Deduction certificate",
      "Working life certificate": "Working life certificate",
      "Last annual Tax Report (Model 100)":
        "Last annual Tax Report (Model 100)",
    },
    FREELANCER_DOCS: {
      // "Employment contract": "Employment contract",
      "Working life certificate": "Working life certificate",
      "Last annual Tax Report (Model 100)":
        "Last annual Tax Report (Model 100)",
      "Last Fractionated Tax Report (Model 130)":
        "Last Fractionated Tax Report (Model 130)",
      "Deduction certificate": "Deduction certificate",
      "Last quarterly VAT tax (Form 303)": "Last quarterly VAT tax (Form 303)",
    },
    RETIRED_DOCS: {
      "Comprehensive certificate of benefits":
        "Comprehensive certificate of benefits",
      "Last revalorization letter": "Last revalorization letter",
    },
    UNEMPLOYED_DOCS: {
      "Working life certificate": "Working life certificate",
      "Comprehensive certificate of benefits":
        "Comprehensive certificate of benefits",
      "Last annual Tax Report (Model 100)":
        "Last annual Tax Report (Model 100)",
    },
    SELF_EMPLOYED_DOCS: {
      "Working life certificate": "Working life certificate",
      "Last annual Tax Report (Model 100)":
        "Last annual Tax Report (Model 100)",
      "Last Fractionated Tax Report (Model 130)":
        "Last Fractionated Tax Report (Model 130)",
      "Deduction certificate": "Deduction certificate",
      "Last year's Corporate Tax Return": "Last year's Corporate Tax Return",
      "Last year's Corporate balance sheet":
        "Last year's Corporate balance sheet",
      "Last year's Corporate P&L": "Last year's Corporate P&L",
      "Company Incorporation Documents": "Company Incorporation Documents",
    },
    PUBLIC_SERVANT_DOCS: {
      "Deduction certificate": "Deduction certificate",
      "Working life certificate": "Working life certificate",
      "Last annual Tax Report (Model 100)":
        "Last annual Tax Report (Model 100)",
      Payslip: "Payslip",
      "Official Appointment Notice (Official Gazette)":
        "Official Appointment Notice (Official Gazette)",
    },
    COMPANY_DOCS: {
      "Company Incorporation Documents": "Company Incorporation Documents",
      "Last year's Corporate Tax Return": "Last year's Corporate Tax Return",
      "Last quarterly VAT tax (Form 303) Q1":
        "Last quarterly VAT tax (Form 303) Q1",
      "Last quarterly VAT tax (Form 303) Q2":
        "Last quarterly VAT tax (Form 303) Q2",
      "Last quarterly VAT tax (Form 303) Q3":
        "Last quarterly VAT tax (Form 303) Q3",
      "Last quarterly VAT tax (Form 303) Q4":
        "Last quarterly VAT tax (Form 303) Q4",
    },
  },
  PERSONAL_USE: "personalUse",
  PROFESSIONAL_USE: "professionalUse",
  INDIVIDUAL_PROPERTY_OWNER: "individualPropertyOwner",
  REAL_ESTATE_AGENT: "realEstateAgent",
  REAL_ESTATE_AGENCY_OWNER: "realEstateAgencyOwner",
  ASSET_MANAGER: "assetManager",
  AUTOMATE_TENANT_SCREENING: "automateTenantScreening",
  AVOID_FRAUD_MANIPULATION: "avoidFraudManipulation",
  IMPROVE_RISK_PORTFOLIO: "improveRiskPortfolio",
  REDUCE_INSURANCE_SPEND: "reduceInsuranceSpend",
  DONT_KNOW: "dontKnow",
  FRIEND_COLLEAGUE_RECOMMENDATION: "friendColleagueRecommendation",
  SEARCHING_GOOGLE: "searchingGoogle",
  PODCAST_YOUTUBE: "podcastYoutube",
  INSTAGRAM_TIKTOK: "instagramTiktok",
  SAW_EVENT_CONGRESS: "sawEventOrCongress",
  dummyProfiles: ["demotenant@skortorent.com", "demoguarantor@skortorent.com"],
  WORKSPACE_ROLES: ["GOLD", "SILVER", "BRONZE", "GUEST"],
  CLARITY_DELAY: 200, // in ms
  DEA_OVERLAY: {
    EFFORT_RATE: [
      {
        label: "Less than 20%",
        min: 0,
        max: 20,
        score: +3,
      },
      {
        label: "20–29%",
        min: 20,
        max: 30,
        score: +2,
      },
      {
        label: "30–34%",
        min: 30,
        max: 35,
        score: +1,
      },
      {
        label: "35–39%",
        min: 35,
        max: 40,
        score: 0,
      },
      {
        label: "Greater than equal to 40%",
        min: 40,
        max: 10000,
        score: -1,
      },
    ],
    TENURE: [
      {
        label: "Greater than equal to 36 months",
        min: 36,
        max: 10000,
        score: +2,
      },
      {
        label: "12–36 months",
        min: 12,
        max: 36,
        score: +1,
      },
      {
        label: "6–12 months",
        min: 6,
        max: 12,
        score: 0,
      },
      {
        label: "Less Than 6 months",
        min: -1,
        max: 6,
        score: -1,
      },
    ],
    INCOME_TYPE: [
      {
        label: "Government Employee",
        labelId: ["5b298ec1-c706-433d-8f1f-10ceff26ea00"],
        score: +2,
      },
      {
        label: "Private Company",
        labelId: [
          "8fecad7f-7e4c-4973-b8f9-e1ca92c9d06a",
          "a0f3919d-77d3-4171-b7bc-2dfe080a1cc8",
          "4647d1f7-2f71-42d6-9798-ab2117fa5348",
        ],
        score: +1,
      },
      {
        label: "Unemployed",
        labelId: ["8265776f-1a61-4512-abf4-2e4da7804aac"],
        score: -1,
      },
      {
        label: "Household Employee",
        labelId: ["8b0c8689-ab41-4c97-ade5-a4d3ac8340e0"],
        score: 0,
      },
      {
        label: "Salaried Employee",
        labelId: ["dcc46e3f-74d9-444b-8fba-8e1d8452ae95"],
        score: +1,
      },
      {
        label: "Pensioner",
        labelId: ["87e645b9-fcfa-49cb-8bc1-e5229d6cf430"],
        score: +2,
      },
      {
        label: "Self-Employed",
        labelId: ["3646671a-d105-4ee9-8c64-1e1ecd710108"],
        score: 0,
      },
      {
        label: "Self-Employed(Bussiness Owner)",
        labelId: ["578b34a5-84ce-4d15-b787-1a4dfb76021a"],
        score: 1,
      },
      {
        label: "No Income",
        labelId: ["8265776f-1a61-4512-abf4-2e4da7804aac"],
        score: -1,
      },
      {
        label: "Unknown",
        score: -1,
      },
      // Foreigner =>
    ],
    CONTRACT_TYPE: [
      {
        label: "Permanent / Indefinite",
        labelId: ["dcc46e3f-74d9-444b-8fba-8e1d8452ae95"],
        score: +2,
      },
      {
        label: "Temporary (Project/Service)",
        labelId: ["3065f4e1-3794-404e-aa15-81de42a42de2"],
        score: 0,
      },
      {
        label: "Temporary with End Date",
        labelId: ["e6b48dc8-4b74-4170-aff9-4573bbf3a176"],
        score: -1,
      },
      {
        label: "Discontinuous",
        labelId: ["8b0c8689-ab41-4c97-ade5-a4d3ac8340e0"],
        score: +1,
      },
      // {
      //   label: "Others",
      //   score: 0,
      // },
      {
        label: "No Income",
        score: -1,
      },
    ],
    RISK_SECTORS: [
      {
        label: "Restaurants",
        labelId: ["ea03ce10-5048-4b4e-b7c7-3b7cd46b862a"],
        score: -1,
      },
      {
        label: "Leisure & Tourism",
        labelId: ["b3875c97-8695-4d8a-a4f0-dcf1c0a45688"],
        score: -1,
      },
      {
        label: "Technology",
        labelId: ["19354c9b-bcc3-4e7b-9de3-ea5f0bf7998a"],
        score: +1,
      },
      {
        label: "Commerce / Retail",
        labelId: [
          "4ecb9dff-6c3a-4a21-887e-93130624b0af",
          "5dd152ab-3561-4eba-9521-a765f9193d3d",
        ],
        score: -1,
      },
      {
        label: "Others",
        score: 0,
      },
    ],
    INCOME_TO_CONTRACT_MAP: {
      // Government Employee → Permanent
      "5b298ec1-c706-433d-8f1f-10ceff26ea00":
        "dcc46e3f-74d9-444b-8fba-8e1d8452ae95",
      // Self-Employed(Business Owner) → Permanent
      "578b34a5-84ce-4d15-b787-1a4dfb76021a":
        "dcc46e3f-74d9-444b-8fba-8e1d8452ae95",
      // Pensioner → Permanent
      "87e645b9-fcfa-49cb-8bc1-e5229d6cf430":
        "dcc46e3f-74d9-444b-8fba-8e1d8452ae95",
      // Self-Employed → Permanent
      "3646671a-d105-4ee9-8c64-1e1ecd710108":
        "dcc46e3f-74d9-444b-8fba-8e1d8452ae95",
      // No Income / Unemployed → No Income
      "8265776f-1a61-4512-abf4-2e4da7804aac": "NO_INCOME",
      // (Unknown handled separately since no labelId)
    },
  },
  SKIP_STEPS_ENUM: {
    bank_onboarding: "bank_onboarding",
    guarantor_onboarding: "guarantor_onboarding",
    kyc_onboarding: "kyc_onboarding",
    context_onboarding: "context_onboarding",
    consent_onboarding: "consent_onboarding",
  },
  DIRECT_INSURANCE_WHITELIST: [
    "invinte_b2c_tenants@yopmail.com",
    "namandeep.seraphic@yopmail.com",
  ],
};
